export default __webpack_public_path__ + "static/media/allBooks.8450b525.png";